import { render, staticRenderFns } from "./freezerNumStatistics.vue?vue&type=template&id=6243e07b&"
import script from "./freezerNumStatistics.vue?vue&type=script&lang=js&"
export * from "./freezerNumStatistics.vue?vue&type=script&lang=js&"
import style0 from "./freezerNumStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports